import { $, $$ } from '@3pc/dom';
import Slider from 'modules/glide/glide';

const imageSliders = $$('.image-gallery');
if (imageSliders.length) {
  imageSliders.forEach(imageSlider => {
    const slider = $('.glide', imageSlider);

    new Slider(slider, {
      config: {
        type: 'slider',
        gap: '40',
        peek: '300',
        rewind: false,
        controls: true,
        bullets: false,
        numeric: true,
        perView: 1,
        startAt: 0,
        appendTarget: $('.glide__controls-wrapper', imageSlider),
        breakpoints: {
          1199: {
            peek: '0',
          },
        },
      },
    }).init();
  });
}
